import { httpClient } from '@/lib/api/httpClient'
import type { Vendor } from '@/shared/types'

export const vendorApi = {
  fetchVendor: async (vendorId: string): Promise<Vendor | null> => {
    const response = await httpClient.get(`/vendors/${vendorId}`)
    return response.data?.data?.vendor ?? null
  },

  fetchLowStock: async (vendorId: string) => {
    const response = await httpClient.get(`/vendors/${vendorId}/low-stock`)
    return response.data?.data
  },

  updateShopStatus: async (vendorId: string, data: { kitchenState?: string; operationalState?: string }) => {
    const response = await httpClient.patch(`/vendors/${vendorId}/shop-status`, data)
    return response.data?.data
  },

  updateCoverImage: async (vendorId: string, imageFile: File): Promise<string> => {
    const formData = new FormData()
    formData.append('coverImage', imageFile)
    const response = await httpClient.patch(`/vendors/${vendorId}/cover-image`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
    return response.data?.data?.coverImage ?? ''
  },
}
